import {
  put,
  all,
  takeLatest,
} from 'redux-saga/effects';
import { sagas as sharingSagas } from './sharing';
import { sagas as dashboardSagas } from './dashboard';
import { sagas as tempDashboardSagas } from './tempDashboard';
import { sagas as baseSagas } from './base'
import * as types from './types';


function* init() {
  yield all([
    put({ type: types.INIT }),
  ])
}

function* reset() {
  yield init();
}

function* watchReset() {
  yield takeLatest(types.RESET, reset);
}

export default [
  init,
  watchReset,
  ...baseSagas,
  ...sharingSagas,
  ...dashboardSagas,
  ...tempDashboardSagas,
];
